export const adminHeaders = [
  { name: "Admin Name" },
  { name: "Created At" },
  { name: "Phone Number" },
  { name: "Email Address" },
  { name: "Role" },
  { name: "Status", auth: true },
  { name: "Action", auth: true },
];

export const customerHeaders = [
  { name: "User Name" },
  { name: "Created Date" },
  { name: "Phone Number" },
  { name: "Email Address" },
  { name: "Bookings" },
  { name: "Revenue" },
  { name: "Cancellations" },
  { name: "Wallet" },
  { name: "Status", auth: true },
  { name: "Actions", auth: true },
];

export const bookingHeaders = [
  { name: "Ticket ID" },
  { name: "Booking Date" },
  { name: "Cx Phone Number" },
  { name: "From - To Location" },
  { name: "Passengers" },
  { name: "Total Price" },
    {name:'Booking Device'},
  { name: "Status", auth: true },
];

export const busHeaders = [
  { name: "Bus No" },
  { name: "Created Date" },
  { name: "Phone Number" },
  { name: "Route Details" },
  { name: "Revenue" },
  { name: "Bookings" },
  { name: "Onboarding Progress" },
  { name: "Status", auth: true },
  { name: "Action", auth: true },
];

export const operatorHeaders = [
  { name: "Operator Name" },
  { name: "Created Date" },
  { name: "Phone Number" },
  { name: "Email" },
  { name: "Fleet Size" },
  { name: "Revenue" },
  { name: "Bookings" },
  { name: "Onboarding Progress" },
  { name: "Role" },
  { name: "Status", auth: true },
  { name: "Action", auth: true },
];

export const couponHeaders = [
  { name: "Coupon Code" },
  { name: "Created At" },
  { name: "Coupon Type" },
  { name: "Discount" },
  { name: "Validity" },
  { name: "Min Fare" },
  { name: "Created By" },
  { name: "Used Count" },
  { name: "Status", auth: true },
  { name: "Action", auth: true },
];

export const cityHeaders = [
  { name: "City Name" },
  { name: "Created Date" },
  { name: "Status", auth: true },
  { name: "Action", auth: true },
];

export const referalHeader = [
  { name: "Refferrer" },
  { name: "Type" },
  { name: "Total Refferals" },
  { name: "Successfull Refferals" },
  { name: "Reward Earned" },
  { name: "Live WB" },
  { name: "Created Date" },
  { name: "Status", auth: true },
  { name: "Actions", auth: true },
];

export const faqHeader = [
  { name: "Questions" },
  { name: "Type" },
  { name: "Category" },
  { name: "Answer" },
  { name: "Actions", auth: false },
];

export const settlementHeaders = [
  { name: "Operator ID" },
  { name: "Operator Name" },
  { name: "Phone Number" },
  { name: "Bus Number" },
  { name: "Travels Name" },
  { name: "Account Number" },
  { name: "Bank Reference No" },
  { name: "Amount" },
  { name: "Amount Status", auth: true },
  { name: "Action", auth: true },
];

export const settlementFareDistributionHeaders = [
  { name: "Booking ID" },
  { name: "Total Passengers" },
  { name: "Luggage Fare" },
  { name: "Route Bus Fee" },
  { name: "Total Amount" },
  { name: "wallet Points Used" },
  { name: "Discounted Price" },
  { name: "Final Fare" },
  { name: "Booking Status", auth: true },
  { name: "Payment Status", auth: true },
];

export const transactionHeaders = [
  { name: "Customer ID" },
  { name: "Customer Name" },
  { name: "Phone Number" },
  { name: "Created AT" },
  { name: "Pay U Reference" },
  { name: "Pay U Transaction ID" },
  { name: "Amount" },
  { name: "Amount Status", auth: true },
  { name: "Booking Status", auth: true },
  { name: "Refunded", auth: true },
  { name: "Action", auth: true },
];

export const walletHeaders = [
  { name: "Sno" },
  { name: "Created At" },
  { name: "Amount" },
  { name: "Balance After" },
  { name: "Type" },
  { name: "Reference Type" },
  { name: "Reference ID" },
  { name: "Descriptions" },
  { name: "Admin Email" },
];

export const tripHeaders = [
  { name: "Trip ID" },
  { name: "Trip Number" },
  { name: "Route ID" },
  { name: "Trip Start Time" },
  { name: "Trip Type" },
  { name: "Total Bookings" },
  { name: "Total Revenue" },
];
